
import { defineComponent, PropType } from 'vue'
import { BillingInterval } from '~/types/types'
export default defineComponent({
  name: 'UI2UpgradePlanCard',
  props: {
    name: {
      type: String,
      required: true
    },
    sku: {
      type: String,
      default: 'target'
    },
    monthlyAmount: {
      type: Number,
      default: 0
    },
    annualAmount: {
      type: Number,
      default: 0
    },
    isFeatured: {
      type: Boolean,
      default: false
    },
    features: {
      type: Array as PropType<string[]>,
      default: () => []
    },
    showUpgradeCta: {
      type: Boolean,
      default: true
    },
    product: {
      type: String,
      required: true
    },
    billingMode: {
      type: String,
      default: 'monthly',
      validator: (value: string | BillingInterval | null) =>
        ['monthly', 'annual', BillingInterval.Annual, BillingInterval.Monthly, null].includes(value)
    },
    showBillingIntervalToggle: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isMonthly() {
      return this.billingMode === 'monthly' || this.billingMode === BillingInterval.Monthly
    },
    upgradeBtnLabel() {
      return `Upgrade to ${this.name}`
    },
    billingModeValue: {
      get() {
        return this.billingMode
      },
      set(value: string) {
        this.$emit('update:billing-mode', value)
      }
    }
  }
})
